"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var vue_1 = tslib_1.__importDefault(require("vue"));
exports.Vue = vue_1.default;
var bootstrap_vue_1 = tslib_1.__importStar(require("bootstrap-vue"));
exports.BoostrapVue = bootstrap_vue_1.default;
require("bootstrap/dist/css/bootstrap.css");
require("bootstrap-vue/dist/bootstrap-vue.css");
var logger_1 = tslib_1.__importDefault(require("../../logger"));
vue_1.default.use(bootstrap_vue_1.default);
vue_1.default.use(bootstrap_vue_1.BootstrapVueIcons);
vue_1.default.config.productionTip = false;
function enableIgnoreVueWarn() {
    var vueInstances = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        vueInstances[_i] = arguments[_i];
    }
    logger_1.default.warn('Ignoring Vue warnings', { label: 'Sigma Client' });
    // Handler that does nothing...
    var nothingHandler = function () { };
    // Set _this_ Vue to nothing
    vue_1.default.config.warnHandler = nothingHandler;
    // Optionally, do the same with any other instances provided
    if (Array.isArray(vueInstances)) {
        vueInstances.forEach(function (vueInstance) {
            vueInstance.config.warnHandler = nothingHandler;
        });
    }
}
exports.enableIgnoreVueWarn = enableIgnoreVueWarn;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/components/plugins/index.js
// module id = ihTb
// module chunks = 0